export default {
    STOP: "Остановить",
    PAUSE: "Пауза",
    PLAY: "Проиграть"
};
